var map = {
	"./add.svg": "eef4",
	"./buy-me-a-coffee-logo.svg": "20f6",
	"./gold-icon.svg": "18af",
	"./logo.svg": "9b19",
	"./magic-icon.svg": "ffef",
	"./strength-icon.svg": "7248",
	"./subtract.svg": "5737",
	"./victory-points-icon.svg": "42cc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2f65";